import React from 'react';
import { NavLink } from 'react-router-dom';
import {
  HomeIcon,
  CalendarDaysIcon,
  PlusCircleIcon,
  BellIcon,
  InformationCircleIcon,
} from '@heroicons/react/24/outline';
import styles from './BottomNav.module.scss';

interface NavItem {
  to: string;
  label: string;
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

const navItems: NavItem[] = [
  { to: '/', label: 'Forside', icon: HomeIcon },
  { to: '/kalender', label: 'Kalender', icon: CalendarDaysIcon },
  { to: '/tilfoej', label: 'Tilføj', icon: PlusCircleIcon },
  { to: '/notifikationer', label: 'Notifikationer', icon: BellIcon },
  { to: '/om', label: 'Om siden', icon: InformationCircleIcon },
];

const BottomNav: React.FC = () => {
  return (
    <nav className={styles.bottomNav} aria-label="Primær navigation">
      {navItems.map((item) => {
        const Icon = item.icon;
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              `${styles.navItem} ${isActive ? styles.active : ''}`
            }
          >
            <Icon className={styles.icon} aria-hidden="true" />
            <span className={styles.label}>{item.label}</span>
          </NavLink>
        );
      })}
    </nav>
  );
};

export default BottomNav;
